module.exports = __webpack_public_path__ + "static/img/2-22-漏发仅退款建单.1631239.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jushuitan/ppt/2-22-漏发仅退款建单.png
// module id = 1359
// module chunks = 0